<template>
    <div>
        <Header/>
        <div class="wrapper-top-margin">
            This is Contact Us
        </div>
    </div>
</template>

<script>
import Header from "../components/Header"
export default {
    components: {
        Header
    }
}
</script>

<style lang="scss" scoped>
    @import "../partials";
    @import "../mixins";
    
</style>